import { ChangeEvent, KeyboardEvent } from 'react';

import { Input, useTheme } from '@chakra-ui/react';

interface CodeInputProps {
  codeLength?: number;
  value: string;
  onChange: (value: string) => void;
}

const CodeInput = ({
  codeLength = 5,
  value = '',
  onChange
}: CodeInputProps) => {
  const {
    colors: {
      palette: {
        auth: {
          reset: {
            confirmationCodeStep: { input }
          }
        }
      }
    }
  } = useTheme();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value;

    if (code.length <= codeLength) {
      onChange(code);
    }
  };

  const onKeyDown = (evt: KeyboardEvent<HTMLInputElement>) => {
    if (evt.key === 'e') {
      evt.preventDefault();
    }
  };

  return (
    <Input
      type='number'
      onKeyDown={onKeyDown}
      onChange={handleChange}
      placeholder='Verification Code'
      borderRadius={0}
      h={{ base: '80px', md: '108px' }}
      maxW={423}
      fontSize={[30, 45]}
      variant='filled'
      value={value}
      textAlign='center'
      bg={input.background}
      verticalAlign='middle'
      _active={{
        bg: input.background
      }}
      _focus={{
        borderColor: input.activeBorder,
        bg: input.background,
        _placeholder: {
          opacity: 0
        }
      }}
      _hover={{
        bg: input.background
      }}
      _placeholder={{
        textTransform: 'uppercase',
        fontSize: { base: '16px', sm: '21px' },
        color: input.placeholder,
        verticalAlign: 'middle',
        position: 'absolute',
        left: 0,
        right: 0,
        top: { base: '28px', md: '40px' }
      }}
    />
  );
};

export default CodeInput;
